import {observable, computed, action} from 'mobx';

class TableRow {
    @observable key;
    @observable amount;
    @observable prevAmount;
    id;

    constructor(data = {}, type) {
        this.key = data[typesMap[type]];
        this.amount = data.amount;
        this.id = data.id;
    }

    @action incrementAmount({amount}) {
        this.prevAmount = this.amount;
        this.amount = this.amount + amount;
    }
}

const typesMap = {
    emotes: 'emote',
    hashtags: 'hashtag',
    commands: 'command',
    chatters: 'name'
};


export default TableRow;



// WEBPACK FOOTER //
// ./src/app/models/TableRow.js